import ArrowDownRight from '@/assets/icons/arrow-down-right.svg?react';
import ArrowTopRight from '@/assets/icons/arrow-up-right.svg?react';
import InfoCircle from '@/assets/icons/info-circle.svg?react';
import {
  AiPerformanceChartPoint,
  AiPerformanceMetric,
} from '@/services/dashboard-service/dashboard.service.types';
import Icon from '@ant-design/icons';
import { Card, Flex, Tooltip } from 'antd';
import { Area, AreaChart, ResponsiveContainer } from 'recharts';
import styles from './ai-performance-card.module.scss';

interface AiPerformanceCardProps {
  title: string;
  tooltip?: string;
  aiPerformanceData?: AiPerformanceMetric;
  aiPerformanceChart?: AiPerformanceChartPoint[];
  isLoading?: boolean;
  arrowColor: string;
}

export default function AiPerformanceCard({
  title,
  aiPerformanceData,
  isLoading,
  aiPerformanceChart,
  arrowColor,
  tooltip,
}: AiPerformanceCardProps) {
  const { change, value } = aiPerformanceData
    ? aiPerformanceData
    : { change: undefined, value: undefined };
  const isPositive = change ? change > 0 : false;

  const arrowIcon = isPositive ? (
    <Icon component={() => <ArrowTopRight width="20" height="20" />} />
  ) : (
    <Icon component={() => <ArrowDownRight width="20" height="20" />} />
  );

  const parsedAiPerformanceChart = aiPerformanceChart?.map((point) => ({
    ...point,
    value: Number(point.value),
  }));

  return (
    <Card
      rootClassName={styles.aiPerformanceCard}
      classNames={{ body: styles.aiPerformanceCardBody }}
      loading={isLoading || !aiPerformanceData}
    >
      <p className={styles.aiPerformanceCardTitle}>{title}</p>
      <ResponsiveContainer width="100%" height={100} className={styles.chartResponsiveContainer}>
        <AreaChart margin={{ left: 0, right: 0 }} data={parsedAiPerformanceChart}>
          <defs>
            <linearGradient id="aiPerformance" x1="0" y1="0" x2="0" y2="1">
              <stop offset="5%" stopColor={styles.primaryColor} stopOpacity={0.6} />
              <stop offset="95%" stopColor={styles.primaryColor} stopOpacity={0} />
            </linearGradient>
          </defs>
          <Area
            type="linear"
            dataKey="value"
            stroke={styles.secondaryColor}
            fillOpacity={1}
            fill="url(#aiPerformance)"
          />
        </AreaChart>
      </ResponsiveContainer>
      <Flex className={styles.aiPerformanceChangesWrapper}>
        <Flex className={styles.aiPerformanceChanges}>
          <span className={styles.aiPerformanceValue}>{value}</span>
          <div className={styles.aiPerformanceChangeContainer} style={{ color: arrowColor }}>
            {arrowIcon}
            <span>{`${change}%`}</span>
          </div>
        </Flex>
        <Tooltip title={tooltip}>
          <Icon
            component={() => <InfoCircle fill="none" height="18" width="18" />}
            className={styles.aiPerformanceInfoIcon}
          />
        </Tooltip>
      </Flex>
    </Card>
  );
}
